/* eslint-disable no-unused-vars */
/* eslint-disable indent */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-console */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Users.css';
import Tabbar from '../../Components/Tabbar/Tabbar';
import { UsersPageComponent } from '../../Components/Pages/UsersPageComponent';
import PageFilter from './../../Components/Pages/PageFilter';
import { del, getAll, add, getRoles, edit, clearSuccess, clearSecondarySuccess } from '../../Store/Actions/RestActions';
import UserGroupsModal from '../../Components/Modals/UserGroupsModal';
import SuccessModal from '../../Components/successModal';
import SecondarySuccessModal from '../../Components/secondarySuccessModal';
import { roles } from '../../Store/Reducers/EntityReducer';
import formatDate from 'dateformat';


class UsersPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activePage: 1,
		
		};
		this.handlePageChange = this.handlePageChange.bind(this);
		this.handleUserExport = this.handleUserExport.bind(this);
		this.getBrowserType = this.getBrowserType.bind(this);
	}

	handleUserExport() {
		var browser = this.getBrowserType();
		this.downloadCSV(browser);
    	
	}

	getBrowserType(browser) {
             
		  let objOffsetVersion = 0;
		  var objAgent = navigator.userAgent; 
		  var objbrowserName = navigator.appName; 
	  
		  // In Chrome 
		  if ((objOffsetVersion=objAgent.indexOf("Chrome"))!==-1)  { 
			  objbrowserName = "Chrome";
		  } 
		  
		  // In Microsoft internet explorer 
		  else if ((objOffsetVersion=objAgent.indexOf("MSIE"))!==-1) { 
			  objbrowserName = "Microsoft Internet Explorer"; 
		  } 

		  // In Firefox 
		  else if ((objOffsetVersion=objAgent.indexOf("Firefox"))!==-1) { 
			  objbrowserName = "Firefox"; 
		  } 
		  
		  // In Safari 
		  else if ((objOffsetVersion=objAgent.indexOf("Safari"))!==-1) { 
		  objbrowserName = "Safari"; 
		  }
		 return objbrowserName;
  	  }



	downloadCSV(browser) {
		const headers = ['UserName', 'UserGroupName', 'FirstName', 'MiddleName', 'LastName', 'Email', 'IsActive', 'IsProtected', 'Notes'];
		var _username = "";
		var _usergroupname = "";
		var _firstname = "";
		var _middlename = "";
		var _lastname = "";
		var _email = "";
		var _notes = "";
		var h = "";
		var dateObj = new Date();
		var month = dateObj.getMonth() + 1;
		if(month < 10)
			month = "0" + month;
		var day = dateObj.getDate();
		 if(day < 10)
		    day = "0" + day.toString();
		var year = dateObj.getFullYear();
		var newDate = year.toString() +  month.toString() +  day.toString();
		var fileData;
		var data;
		var link;
	
		// add our headers
		for (var x = 0; x < headers.length; x++) {
			h = h + headers[x] + ",";
			fileData = h;
		}

		// iterate through user data
		for (var index = 0; index < this.props.users.length; index++) {

			_username = this.props.users[index].userName;
			if (_username == null)
				_username = " ";

			_firstname = this.props.users[index].firstName;
			if (_firstname == null)
				_firstname = " ";

			_middlename = this.props.users[index].middleName;
			if (_middlename == null)
				_middlename = " ";

			_lastname = this.props.users[index].lastName;
			if (_lastname == null)
				_lastname = " ";

				_usergroupname = this.props.users[index].userGroupName;
			if (_usergroupname == null )
			_usergroupname =  " ";

			_email = this.props.users[index].email;
			if (_email == null)
				_email = " ";
		
			_notes = this.props.users[index].notes;
			if (_notes == null)
				_notes = " ";


			// build the csv data string
			fileData = fileData + "\n" + 
				_username.replace(",", " ") + "," + 
				_usergroupname.replace(",", " ") + "," +
				_firstname.replace(",", " ") + "," +
				_middlename.replace(",", " ") + "," +
				_lastname.replace(",", " ") + "," +
				_email.replace(",", " ") + "," + 
				this.props.users[index].isActive + "," +
				this.props.users[index].isProtected + "," +
				_notes.replace(",", " ");
		}


         let csvFileName = "UserExport_" + newDate + ".csv";

		if (window.navigator.msSaveBlob) {
			//Internet Explorer
			window.navigator.msSaveBlob(new Blob([fileData]), csvFileName);
		} 
		if (browser === "Chrome") {
			//Google Chrome and Mozilla Firefox
			var a = document.createElement("a");
			fileData = encodeURIComponent(fileData);
			a.href = "data:application/csv;charset=UTF-8," + fileData;
			a.download = csvFileName;
			a.click();
		} 

		if(browser === "Firefox"){
			if (!fileData.match(/^data:text\/csv/i)) {
				fileData = 'data:text/csv;charset=utf-8,' + '\uFEFF' + fileData;
		}
			data = encodeURI(fileData);
			link = document.createElement('a');
			link.setAttribute('href', data);
			link.setAttribute('download', csvFileName);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}

		 if (browser === "Microsoft Internet Explorer") {
			//Internet Explorer 8 and 9
			var oWin = window.open();
			oWin.document.write("sep=,\r\n" + fileData);
			oWin.document.close();
			oWin.document.execCommand("SaveAs", true, csvFileName);
			oWin.close();
		} 



	// 	// create the csv file
    //     if(browser == 'Chrome'){
	// 		var a = document.createElement('a');
	// 		var blob = new Blob([fileData], { type: 'text/csv' }),
	// 			url = window.URL.createObjectURL(blob);
	// 		a.href = url;
	// 		a.download = "UserExport_" + newDate + ".csv";
	// 		a.click();
	// 		window.URL.revokeObjectURL(url);
	// 		a.remove();
	// }

	// else if(browser == "Firefox"){
	// 	var hiddenElement = document.createElement('a');
    //         hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(fileData);
    //         hiddenElement.target = '_blank';
    //         hiddenElement.download = "UserExport_" + newDate + ".csv";
    //        // document.getElementById('container').appendChild(hiddenElement);
    //         hiddenElement.click();
	// }

	// else if(browser == "Microsoft Internet Explorer") {

	// }
}







	handlePageChange(pageNumber) {
		this.setState({ activePage: pageNumber });
	}

	componentDidMount() {
		this.props.usersFetch(); 
		this.props.userGroupsFetch();
		this.props.rolesFetch();
		
	}

	render() {
		return (

			<div className="container">
				<Tabbar setActiveTab="users" />
				<div className="contentBox tabbed-content-box no-padding">

					<PageFilter {...this.props} pageType={"users"}>
						<UsersPageComponent />
					</PageFilter>

			<div className="gear-container-export">
			   <div className="export-item">
      			<button className="gearBtn-export" onClick={this.handleUserExport}>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22"><defs><clipPath><path fill="#f2f2f2" d="m7 1023.36h1v1h-1z" /></clipPath></defs><path d="m124.92 52.2c-.436-.571-1-.911-1.711-1.019l-14.909-2.281c-.815-2.607-1.929-5.268-3.341-7.984.977-1.358 2.443-3.272 4.398-5.744 1.955-2.472 3.34-4.277 4.155-5.418.435-.598.651-1.222.651-1.874 0-.76-.189-1.357-.57-1.792-1.955-2.771-6.436-7.387-13.443-13.851-.65-.543-1.33-.814-2.035-.814-.815 0-1.467.244-1.956.732l-11.568 8.718c-2.228-1.141-4.672-2.146-7.333-3.02l-2.281-14.99c-.054-.706-.367-1.29-.937-1.752-.571-.462-1.235-.692-1.997-.692h-18.09c-1.575 0-2.553.76-2.933 2.281-.706 2.715-1.494 7.766-2.363 15.15-2.553.816-5.02 1.848-7.414 3.097l-11.243-8.718c-.706-.543-1.412-.814-2.118-.814-1.195 0-3.761 1.941-7.699 5.825-3.938 3.884-6.612 6.803-8.03 8.758-.489.706-.733 1.331-.733 1.874 0 .652.271 1.304.814 1.955 3.639 4.4 6.545 8.147 8.718 11.244-1.358 2.498-2.417 4.997-3.177 7.495l-15.15 2.281c-.597.109-1.113.462-1.548 1.06-.435.597-.652 1.222-.652 1.873v18.09c0 .707.217 1.344.652 1.914.435.571 1 .912 1.711 1.02l14.91 2.2c.76 2.661 1.873 5.349 3.34 8.06-.977 1.358-2.444 3.272-4.399 5.744-1.955 2.472-3.341 4.277-4.155 5.418-.435.599-.652 1.222-.652 1.874 0 .706.19 1.33.57 1.873 2.118 2.934 6.599 7.497 13.443 13.688.598.598 1.277.896 2.037.896.815 0 1.494-.244 2.037-.732l11.488-8.719c2.228 1.141 4.672 2.146 7.333 3.02l2.281 14.99c.055.706.367 1.29.937 1.752.57.463 1.236.692 1.996.692h18.09c1.577 0 2.554-.76 2.935-2.281.705-2.716 1.492-7.766 2.361-15.15 2.553-.815 5.03-1.848 7.414-3.097l11.244 8.8c.76.488 1.467.732 2.118.732 1.194 0 3.747-1.927 7.657-5.784 3.912-3.856 6.6-6.79 8.06-8.8.489-.543.734-1.167.734-1.873 0-.706-.271-1.387-.815-2.037-3.91-4.78-6.816-8.527-8.718-11.243 1.086-2.01 2.146-4.481 3.178-7.414l15.07-2.28c.651-.109 1.196-.463 1.63-1.061.434-.598.65-1.223.65-1.874v-18.09c.0001-.706-.215-1.343-.651-1.914m-47.17 25.541c-4.073 4.074-8.989 6.111-14.747 6.111-5.758 0-10.673-2.037-14.747-6.111-4.073-4.073-6.11-8.988-6.11-14.746 0-5.758 2.036-10.673 6.11-14.747 4.074-4.073 8.99-6.11 14.747-6.11 5.758 0 10.674 2.037 14.747 6.11 4.073 4.074 6.11 8.989 6.11 14.747 0 5.758-2.037 10.673-6.11 14.746" transform="matrix(.12786 0 0 .12786 2.949 2.956)" fill="" /></svg>
					<span>Export Users</span>
				</button>
			</div>
		</div>
			    <UserGroupsModal items={this.
			    props.userGroups}  modalIsOpen={this.state.modalIsopen} handleSubmit={this.props.userGroupAdd} handleEdit={this.props.userGroupEdit} {...this.props} />
			</div>
				<SuccessModal success={this.props.success} successMsg="User action completed successfully." onClose={this.props.clearSuccess}></SuccessModal>								
				<SecondarySuccessModal success={this.props.userGroupsSuccess} successMsg="User Group action completed successfully" onClose={this.props.clearSecondarySuccess}></SecondarySuccessModal>
				
			</div>
		);
	}
}
const mapStateToProps = state => ({
	users: state.users.data,
	userGroups: state.userGroups.data,
	roles: state.roles.data,
	filterData: state.users.data,
	success: state.users.success,
	userGroupsSuccess: state.userGroups.success,
	
});

const mapDispatchtoProps = dispatch => ({
	deleteClick: id => dispatch(del('users', {}, id)),
	usersFetch: () => dispatch(getAll('users', {})),
	userGroupsFetch: () => dispatch(getAll('usergroups', {})),
	userGroupAdd: (data) => dispatch(add('usergroups', data)),
	userGroupEdit: (data) => dispatch(edit('usergroups', data, data.id)),
	userGroupDelete: id => dispatch(del('usergroups', {}, id)),
	addClick: data => dispatch(add('users', data)),
	rolesFetch: () => dispatch(getRoles()),
	clearSuccess: () => dispatch(clearSuccess('users')),
	clearSecondarySuccess: () => dispatch(clearSecondarySuccess('userGroups')),
				
});

export default connect(mapStateToProps, mapDispatchtoProps)(UsersPage);



// WEBPACK FOOTER //
// ./src/Pages/Users/Users.js